import { render, staticRenderFns } from "./WorkflowSnackbar.vue?vue&type=template&id=61d2e9b8&"
import script from "./WorkflowSnackbar.vue?vue&type=script&lang=ts&"
export * from "./WorkflowSnackbar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports